import moment from 'moment';

export const getRelativeTime = (createdAt) => {
  const date = moment(createdAt);
  const diff = moment.duration(moment().diff(date));

  if (diff.asDays() >= 2) {
    return date.format('M/D/YYYY');
  }
  return `${diff.humanize()} ago`;
};
